import React from 'react';
import { Snackbar, Alert } from '@mui/material';

// Small shared helper for the settings pages: a snackbar for save feedback.
export const useSnack = () => {
  const [snack, setSnack] = React.useState({ open: false, severity: 'success', message: '' });
  const showSuccess = (message = 'Settings saved successfully') =>
    setSnack({ open: true, severity: 'success', message });
  const showError = (message) =>
    setSnack({ open: true, severity: 'error', message: message || 'Failed to save settings' });
  const closeSnack = () => setSnack((prev) => ({ ...prev, open: false }));
  return { snack, showSuccess, showError, closeSnack };
};

export const SaveSnackbar = ({ snack, onClose }) => (
  <Snackbar
    open={snack.open}
    autoHideDuration={4000}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
  >
    <Alert onClose={onClose} severity={snack.severity} variant="filled" sx={{ width: '100%' }}>
      {snack.message}
    </Alert>
  </Snackbar>
);
